import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { ApolloCustomerModal } from '@vend/business-components/dist/components/CustomerModal/ApolloCustomerModal'
import { ApiCustomer } from '@vend/types'
import { UpdateSaleCustomerModal } from '../../../../modals/update-customer-modal'
import { wrToastNegative } from '../../helios/ToastNotifications/WrToastNotifications'
import { StoreCreditModal } from '../../../../modals/store-credit-modal'

type Props = {
  onClose: () => void
  customer: ApiCustomer
}
/**
 * View customer modal shown when click customer badge on customer search
 */
export const ViewCustomerModal = (props: Props) => {
  const [showEditModal, setShowEditModal] = useState(false)
  const [showStoreCreditModal, setShowStoreCreditModal] = useState(false)
  const { onClose, customer } = props

  const onEdit = () => setShowEditModal(true)

  const onError = () => {
    wrToastNegative('customer.view.modal.negative')
    onClose()
  }

  const onIssueStoreCredit = () => setShowStoreCreditModal(true)

  // edit customer modal
  if (showEditModal) {
    return <UpdateSaleCustomerModal onClose={onClose} />
  }

  // store credit modal
  if (showStoreCreditModal) {
    return ReactDOM.createPortal(
      <StoreCreditModal customer={customer} onClose={onClose} />,
      document.body
    )
  }

  // customer modal
  return ReactDOM.createPortal(
    <ApolloCustomerModal
      customerId={customer.id}
      onEdit={onEdit}
      onIssueStoreCredit={onIssueStoreCredit}
      onError={onError}
      onClose={onClose}
    />,
    document.body
  )
}
